<div>
   <p class="qr-title">QR tributario:</p>
   <ngx-qrcode *ngIf="value.length > 1"
     [elementType]="elementType"
     [errorCorrectionLevel]="correctionLevel"
     [value]="value"
     [width]="142"
     cssClass="qrcodeshadow">
   </ngx-qrcode>
   <p class="qr-description">VERI*FACTU</p>
   <!-- <p class="qr-url">{{ value }}</p> -->
     <!-- [width]="190"  esto serían 4 cm-->

 </div>
 